export { default } from './Provider.container';


// WEBPACK FOOTER //
// ./src/components/Provider/index.ts